<mat-card>
  <mat-card-content>
    <img *ngIf="!needsOldPassword" src="assets/img/logo_alcmeon_horizontal.png" />

    <form *ngIf="form" [formGroup]="form" (ngSubmit)="changePassword()">
      <div class="limitations" *ngIf="limitations?.length">
        <p [innerHtml]="introduction"></p>
        <div class="limitation" *ngFor="let limitation of limitations" [attr.data-testid]="'text-' + limitation.code">
          {{ limitation.text }}
        </div>
      </div>

      <p *ngIf="needsOldPassword">
        <mat-form-field>
          <mat-label>
            <span translate="password-confirm/old-password"></span>
          </mat-label>
          <input
            data-testid="old-password"
            matInput
            autocomplete="off"
            formControlName="oldPassword"
            [type]="showPassword['old-password'] ? 'text' : 'password'" />
          <mat-icon
            class="password-visibility"
            matSuffix
            (click)="showPassword['old-password'] = !showPassword['old-password']">
            {{ showPassword['old-password'] ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </mat-form-field>
      </p>

      <p>
        <mat-form-field>
          <mat-label>
            <span translate="password-confirm/new-password"></span>
          </mat-label>

          <input
            data-testid="password"
            matInput
            autocomplete="off"
            formControlName="password"
            [type]="showPassword['password'] ? 'text' : 'password'" />
          <mat-icon
            class="password-visibility"
            matSuffix
            (click)="showPassword['password'] = !showPassword['password']">
            {{ showPassword['password'] ? 'visibility_off' : 'visibility' }}
          </mat-icon>
          <mat-error
            data-testid="current-password"
            *ngIf="passwordCtrl.hasError('current-password')"
            translate="password-confirm/dont-reuse-password"></mat-error>
          <mat-error
            data-testid="error-at-least-one-big-cap-in-password"
            *ngIf="passwordCtrl.hasError('at-least-one-big-cap-in-password')"
            translate="password-confirm/at-least-one-big-cap-in-password"></mat-error>
          <mat-error
            data-testid="error-at-least-one-number-in-password"
            *ngIf="passwordCtrl.hasError('at-least-one-number-in-password')"
            translate="password-confirm/at-least-one-number-in-password"></mat-error>
          <mat-error
            data-testid="error-at-least-one-small-cap-in-password"
            *ngIf="passwordCtrl.hasError('at-least-one-small-cap-in-password')"
            translate="password-confirm/at-least-one-small-cap-in-password"></mat-error>
          <mat-error
            data-testid="error-min-special-characters"
            *ngIf="passwordCtrl.hasError('min-special-characters')"
            translate="password-confirm/min-special-characters"></mat-error>
          <mat-error
            data-testid="error-min-characters"
            *ngIf="passwordCtrl.hasError('too-short')"
            translate="password-confirm/too-short"></mat-error>
          <mat-error
            data-testid="error-missing-special-char"
            *ngIf="passwordCtrl.hasError('missing-special-char')"
            translate="password-confirm/missing-special-char"></mat-error>
        </mat-form-field>
      </p>

      <p>
        <mat-form-field data-testid="confirm-password-field">
          <mat-label>
            <span translate="password-confirm/confirm-new-password"></span>
          </mat-label>
          <input
            data-testid="confirm-password"
            matInput
            autocomplete="off"
            formControlName="confirmPassword"
            [type]="showPassword['confirm-password'] ? 'text' : 'password'" />
          <mat-icon
            class="password-visibility"
            matSuffix
            (click)="showPassword['confirm-password'] = !showPassword['confirm-password']">
            {{ showPassword['confirm-password'] ? 'visibility_off' : 'visibility' }}
          </mat-icon>
          <mat-error
            *ngIf="confirmPasswordCtrl.hasError('do-not-match')"
            translate="password-confirm/do-not-match"></mat-error>
        </mat-form-field>
      </p>

      <button
        mat-raised-button
        [disabled]="form.invalid"
        data-testid="submit"
        type="submit"
        color="primary"
        translate="password-change/submit"></button>
    </form>
  </mat-card-content>
</mat-card>
